import css from "./index.module.css";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import Header from "../../../components/Header";
import Loading from "../../../components/Loading";
import StudentsList from "./Students/StudentsList";
import ChallengeList from "./Challenges/ChallengeList";

import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { deleteData, getDataById, updateData } from "../../../utils/fetch";

/**
 * displays gerneral Information of an class, a <StudentList /> as well as a <ChallengeList />
 * @param {String} id 64 character uuid of given class
 */
const Class = ({ classId, teacherId }) => {
  const [data, setData] = useState(null);
  const [students, setStudents] = useState(null);
  const [changedClassName, setChangedClassName] = useState(false);
  const [changedClassGrade, setChangedClassGrade] = useState(false);
  const [changedClassCode, setChangedClassCode] = useState(false);

  useEffect(() => {
    getDataById("/api/classes/byId", { id: classId }).then((e) => {
      setData(e);
    });
    getDataById("/api/students/byClass", { classId: classId }).then((data) =>
      setStudents(data)
    );
  }, [classId]);

  const updateClassInformation = (e) => {
    const form = new FormData(e.target);
    const name = form.get("className");
    const id = form.get("classId");
    const grade = form.get("classGrade");
    const code = form.get("classCode");

    updateData("/api/classes", {id: id, className: name, classGrade: grade, classCode: code}).then(() => {
      getDataById("/api/classes/byId", {id: id}).then(e => setData(e));
    })
  }

  const deleteClass = () => {
    deleteData("/api/classes", {id: classId})
  }

  return (
    <div className={css.page}>
      
      <Header isTeacher={true} nav="Klassen" />
      <div className={css.classContainer}>
        {data?.length === null ? <Loading /> : (
          <div className={css.container}>
            <h2>Klasse</h2>
            <form className={css.form} onSubmit={updateClassInformation}>
              <Input type="text" label="Klassen ID" defaultValue={classId ? classId : null} name="classId" disabled={true}/>
              <Input
                type="text"
                label="Class Name"
                name="className"
                defaultValue={data ? data[0].name : null}
                onChange={() => setChangedClassName(true)}
              />
              <Input
                type="number"
                label="Class Grade"
                name="classGrade"
                min={0}
                max={13}
                defaultValue={data ? data[0].grade : null}
                onChange={() => setChangedClassGrade(true)}
              />
              <Input
                type="text"
                label="Class Code"
                name="classCode"
                defaultValue={data ? data[0].classcode : null}
                onChange={() => setChangedClassCode(true)}
                disabled={true}
              />
              <div className={css.buttons}>
                {(changedClassName || changedClassGrade || changedClassCode) ? 
                (
                  <Button type="submit">Speichern</Button>
                ) : (
                  <Button disabled type="submit">Speichern</Button>
                )} 
              </div>
            </form>
            <Link to={`/teacher/${teacherId}`}>
                <Button onClick={() => deleteClass()}>Löschen</Button>
            </Link>
            
            <Link to={`/teacher/${teacherId}/progress/${classId}`}>
                <Button>Lernfortschritt</Button>
            </Link>
          </div>
        )}

        <div className={css.container}>
          <h2>Schüler:innen</h2>
          <StudentsList
            students={students}
            classId={classId}
            setStudents={setStudents}
          />
        </div>
        
        {data === null || data?.length === 0 ? <Loading /> : (
          <div className={css.container}>
            <h2>Challenges</h2>
            <ChallengeList classId={classId} classGrade={data[0]?.grade} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Class;
